export default __webpack_public_path__ + "assets/images/c31684f5bb6c63b47e82a0e5ab934efd.png";